<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel  v-bind:title='title'>
        <v-btn
          slot="action"
          class="indigo accent-1"
                   
          light
          small
          absolute
          right
          middle
          fab
        >
          <v-icon>add</v-icon>
        </v-btn>
        <div slot="top">
          <EditorReportsPeopleTable /> 
        </div>         
      </panel>
            
    </v-flex>
  </v-layout>
</template>

<script>

import Panel from "@/components/Panel" ;
import EditorReportsPeopleTable from "@/components/EditorReportsPeopleTable" ;

export default {
  components: {
    Panel, EditorReportsPeopleTable
  },
  data () {
    return {      
      title: 'Editor Report'
    };
  },
  methods: { 
  },
  async created () {
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },
  async mounted () {
    console.log("++++++++++++++++++++++++++++++++ EditorReportsPeople MOUNTED") ;
    if (this.$route.query.description) this.title = "Editor Report " + this.$route.query.description ;
  }  
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EditorReportsPeople.vue